export const MOBILE_DEBUG_VERSION = "v2026.04.09-01";
